import useMediaQuery from 'beautiful-react-hooks/useMediaQuery';
import { useEffect, useState } from 'react';

const usePrintMode = () => {
  const isMediaPrint = useMediaQuery('print');
  const [printMode, setPrintMode] = useState(isMediaPrint);

  useEffect(() => {
    const enablePrintMode = () => {
      setPrintMode(true);
    };
    const disablePrintMode = () => {
      setPrintMode(false);
    };

    window.addEventListener('beforeprint', enablePrintMode);
    window.addEventListener('afterprint', disablePrintMode);

    return () => {
      window.removeEventListener('beforeprint', enablePrintMode);
      window.removeEventListener('afterprint', disablePrintMode);
    };
  }, []);

  return printMode || isMediaPrint;
};

export default usePrintMode;
